<template>
  <div class="layout" id="myComponentDiv">
    <div class="box-titulo">Reporte de Ventas con Placa</div>
    <div class="box-container">
      <div class="box-filtres">
        <table>
          <tbody>
            <tr>
              <td width="150px">
                <input id="fechainicio" placeholder="Fecha inicio" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="150px">
                <input id="fechafin" placeholder="Fecha final" datatype="fecha" type="text" class="form-control"
                  autocomplete="off" v-on:change="trigger()" />
              </td>
              <td width="280px">
                <Select2 v-model="cliente" :options="clientes" />
              </td>
              <td>
                <button class="btn btn-warning" type="submit" v-on:click="getReporteEquipos">
                  Consultar
                </button>
                <button class="btn btn-success" type="submit" v-on:click="getReporteEquiposExcel">
                  <i class="fa-regular fa-file-excel"></i>
                  <span class="ml-1">Exportar</span>
                </button>
              </td>
              <td>
                <div v-if="loading">
                  <img src="dist/img/kubber-loading.gif" style="width: 30px" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="containter-table" class="containter-table">
        <DataTable :columns="table.columns" :data="reporte" :options="table.options" class="display nowrap"
          style="width: 100%" />
      </div>


      <!-- RESUMEN EN 2 COLUMNAS -->
      <div class="resumen-grid">
        <!-- IZQUIERDA: RESUMEN POR MEDIOS DE PAGO -->
        <div class="resumen-col" v-if="false">
          <table width="100%" class="table font-oswald">
            <tbody>
              <tr class="fila-hover">
                <td class="subtable" colspan="2">RESUMEN MEDIOS DE PAGO</td>
              </tr>

              <tr v-if="resumenPagosList.length === 0" class="fila-hover">
                <td class="subtable" colspan="2">Sin medios de pago</td>
              </tr>

              <tr v-for="(p, i) in resumenPagosList" :key="i" class="fila-hover">
                <td class="subtable">{{ p.medio_descripcion }}</td>
                <td class="subtable b text-right">{{ GLOBAL.FORMATO_MONEY(p.valor) }}</td>
              </tr>

              <tr v-if="resumenPagosList.length > 0" class="fila-hover">
                <td class="subtable b">TOTAL PAGOS</td>
                <td class="subtable b text-right">{{ GLOBAL.FORMATO_MONEY(resumenPagosTotal) }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- DERECHA: RESUMEN ACTUAL -->
        <div class="resumen-col">
          <table width="100%" class="table font-oswald">
            <tbody>
              <tr class="fila-hover">
                <td class="subtable" width="150px">TRANSACCIONES</td>
                <td class="subtable b text-right">
                  {{ totalventas }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL CANTIDAD</td>
                <td class="subtable b text-right">
                  {{ fcantidad }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL IMPUESTOS</td>
                <td class="subtable b text-right">
                  {{ ftotalimpuestos }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL VENTAS</td>
                <td class="subtable b text-right">
                  {{ ftotales }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">TOTAL DESCUENTOS</td>
                <td class="subtable b text-right">
                  {{ fdescuentos }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">FECHA INICIO</td>
                <td class="subtable b text-right">
                  {{ fecha_inicio_reporte }}
                </td>
              </tr>
              <tr class="fila-hover">
                <td class="subtable">FECHA FINAL</td>
                <td class="subtable b text-right">
                  {{ fecha_final_reporte }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>


      <div id="myModal" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Venta # {{ venta._id }}</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body bg-gray">
              <div class="bg-gray">
                <div class="bg-gray">
                  <FacturaPosView :key="facturaKey" :object="factura" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="!permiso_lista">
        {{ this.person.nombre }}, {{ this.GLOBAL.MENSAJE.SIN_AUTORIZACION }}
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../../Global.js";
import axios from "axios";
import ReporteService from "../../service/ReporteService";
import ClienteService from "../../service/ClienteService";
import FacturaPosView from "../../components/FacturaPosView.vue";

import Select2 from "vue3-select2-component";

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net";
import Buttons from "datatables.net-buttons";
import ButtonsHtml5 from "datatables.net-buttons/js/buttons.html5";

DataTable.use(DataTablesCore);
DataTable.use(Buttons);
DataTable.use(ButtonsHtml5);

export default {
  components: { DataTable, FacturaPosView, Select2 },
  data() {
    return {
      GLOBAL,
      reporteService: null,
      person: null,
      mostrarEDS: false,
      permiso_lista: false,
      reporte: [],
      clienteService: null,
      clientes: [],
      cliente: "",
      totalventas: 0,
      totaleds: 0,
      totalimpuestos: 0,
      totales: 0,
      ftotalimpuestos: "$ 0",
      ftotales: "$ 0",
      totalCantidad: 0,
      fcantidad: "0",
      fecha_inicio_reporte: "",
      fecha_final_reporte: "",
      venta: [],
      facturaKey: 0,
      factura: [],
      loading: true,

      // NUEVO: resumen por medios de pago
      resumenPagos: {}, // { "EFECTIVO": 123, "TARJETA": 456 }
      resumenPagosList: [], // [{medio_descripcion, valor}]
      resumenPagosTotal: 0,

      table: {
        columns: [
          { title: "Fecha", data: "fecha", class: "text-center" },
          { title: "Tipo", data: "codigo", class: "text-center" },
          { title: "Consecutivo", data: "consecutivo" },
          { title: "Mang", data: "manguera" },
          { title: "Lec.Inicial", data: "inicial" },
          { title: "Lec.Final", data: "final" },
          { title: "Fec.Inicial", data: "fecha_inicial" },
          { title: "Fec.Final", data: "fecha_final" },
          { title: "Operador", data: "persona_nombre" },
          { title: "Cliente", data: "tercero_nombre" },
          { title: "Flota", data: "flota_desc" },
          { title: "Placa", data: "placa" },
          { title: "KM", data: "kilometraje", class: "text-right" },
          { title: "Presión", data: "presion", class: "text-right" },
          { title: "Impuesto", data: "impuesto_total", class: "text-right" },
          { title: "Cant", data: "cantidad", class: "text-right" },
          { title: "Venta", data: "venta_subtotal", class: "text-right" },
          {
            data: null,
            sortable: false,
            render: function (data, type, full, meta) {
              if (full.documento != 27) {
                return `<button class="btn btn-sm btn-info" data-id="${full.item}" id="edit">
                                            <i class="fa-solid fa-receipt"></i>
                                        </button>`;
              } else {
                return "";
              }
            },
          },
        ],
        options: {
          ...GLOBAL.TABLE_OPTIONS,
          createdRow: function (row, data, dataIndex) {
            const vueInstance = this;
          }.bind(this),
        },
      },
    };
  },
  created() {
    this.person = JSON.parse(sessionStorage.getItem(GLOBAL.SESSION_KEY));
    this.permiso_lista = this.person.funciones.includes(
      GLOBAL.PERMISOS.REPORTE.HOROMETRO
    );

    this.reporteService = new ReporteService();
    this.clienteService = new ClienteService();

    this.factura = {};
    this.factura.empresa = {};
    this.factura.consecutivo = {};
    this.factura.origen = {};
    this.factura.promotor = {};
    this.factura.invoiceTaxExclusiveTotal = 0.0;

    $(document).on("click", "#edit", (event) => {
      const buttonID = $(event.currentTarget).data("id");
      this.openMe(buttonID);
    });
  },
  mounted() {
    var fecha = new Date();
    $("#fechainicio").val(
      fecha.getFullYear() +
      "-" +
      (fecha.getMonth() + 1 <= 9
        ? "0" + (fecha.getMonth() + 1)
        : fecha.getMonth() + 1) +
      "-" +
      (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
      " 00:00"
    );
    $("#fechafin").val(
      fecha.getFullYear() +
      "-" +
      (fecha.getMonth() + 1 <= 9
        ? "0" + (fecha.getMonth() + 1)
        : fecha.getMonth() + 1) +
      "-" +
      (fecha.getDate() <= 9 ? "0" + fecha.getDate() : fecha.getDate()) +
      " 23:59"
    );

    $("input[datatype='fecha']").datetimepicker();
    this.table = $("#containter-table").html();

    this.getListaCliente();
    this.getReporteEquipos();
  },
  methods: {
    getListaCliente() {
      this.loading = true;
      this.clienteService
        .getReporteClientes(this.person)
        .then((data) => {
          this.clientes = [];
          for (var i in data) {
            this.clientes.push({ id: data[i]._id, text: data[i].nombres });
          }
        })
        .then(() => {
          this.loading = false;
        });
    },

    refrescarFactura() {
      this.facturaKey += 1;
    },

    openMe(item) {
      this.venta = this.reporte[item];
      this.reporteService
        .getFacturaWithEmpresa(this.person, this.venta)
        .then((data) => {
          this.factura = data;
          this.refrescarFactura();
        })
        .then(() => {
          $("#myModal").modal("show");
        });
    },

    calcularResumenMediosPago() {
      this.resumenPagos = {};
      this.resumenPagosList = [];
      this.resumenPagosTotal = 0;

      // IMPORTANTE:
      // Tu query trae 1 fila por detalle (movimientos_detalles),
      // entonces los medios de pago se repiten por cada detalle.
      // Para no duplicar, acumulamos pagos 1 sola vez por movimiento (_id).
      const movVistos = new Set();

      for (const r of this.reporte) {
        const movId = r._id;
        if (movVistos.has(movId)) continue;
        movVistos.add(movId);

        const pagos = Array.isArray(r.medios_pago) ? r.medios_pago : [];
        for (const p of pagos) {
          const k = (p.medio_descripcion || "SIN DESCRIPCIÓN").trim();
          const v = Number(p.valor || 0);

          if (!this.resumenPagos[k]) this.resumenPagos[k] = 0;
          this.resumenPagos[k] += v;
          this.resumenPagosTotal += v;
        }
      }

      this.resumenPagosList = Object.keys(this.resumenPagos)
        .map((k) => ({ medio_descripcion: k, valor: this.resumenPagos[k] }))
        .sort((a, b) => b.valor - a.valor);
    },

    getReporteEquipos() {
      this.reporte = [];

      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      this.loading = true;

      this.reporteService
        .getListaMovimientosPlaca(
          this.person,
          fechainicio,
          fechafin,
          GLOBAL.DOCUMENTO.FACTURA_POS,
          this.cliente
        )
        .then((data) => {
          this.totalventas = 0;
          this.totalCantidad = 0;
          this.totaleds = 0;

          this.totalimpuestos = 0;
          this.totales = 0;

          var eds = [];

          var x = 0;
          for (const i in data) {
            eds[data[i].estacion] = 1;

            this.reporte[x] = [];
            this.reporte[x].hash = data[i].hasp;
            this.reporte[x].prefijo = data[i].prefijo;
            this.reporte[x].numero = data[i].consecutivo;

            this.reporte[x].codigo = data[i].codigo;
            this.reporte[x].documento = data[i].documento;

            var fecha = data[i].fecha.split(".")[0].replace("T", " ");

            this.reporte[x].item = x;
            this.reporte[x]._id = data[i]._id;
            this.reporte[x].estacion = data[i].estacion;
            this.reporte[x].consecutivo =
              data[i].prefijo + "-" + data[i].consecutivo;
            this.reporte[x].fecha = fecha;
            this.reporte[x].manguera = "M-" + data[i].manguera;

            this.reporte[x].persona_nombre = data[i].persona_nombre;
            this.reporte[x].placa = data[i].placa;
            this.reporte[x].kilometraje = data[i].kilometraje;
            this.reporte[x].presion = data[i].presion;
            this.reporte[x].cantidad = GLOBAL.FORMATO_NUMBER(data[i].cantidad);
            this.reporte[x].venta_subtotal = GLOBAL.FORMATO_MONEY(
              data[i].venta_total
            );
            this.reporte[x].impuesto_total = GLOBAL.FORMATO_MONEY(
              data[i].impuesto_total
            );

            try {
              this.reporte[x].fecha_inicial =
                data[i].atributos.auditoria.fecha_inicial;
              this.reporte[x].fecha_final =
                data[i].atributos.auditoria.fecha_final;

              this.reporte[x].inicial =
                data[i].atributos.auditoria.lectura_inicial;
              this.reporte[x].final = data[i].atributos.auditoria.lectura_final;
            } catch (error) {
              this.reporte[x].fecha_inicial = "";
              this.reporte[x].fecha_final = "";

              this.reporte[x].inicial = "";
              this.reporte[x].final = "";
            }

            this.reporte[x].flota_desc = data[i].flota_desc;
            this.reporte[x].tercero_nit = data[i].tercero_nit;
            this.reporte[x].tercero_nombre =
              data[i].tercero_nombre.toUpperCase();
            x++;

            this.totalCantidad += data[i].cantidad;
            this.totalimpuestos += data[i].impuesto_total;
            this.totales += data[i].venta_total;
          }

          for (const i in eds) {
            this.totaleds++;
          }

          this.totalventas = x;

          this.fcantidad = GLOBAL.FORMATO_NUMBER(this.totalCantidad);
          this.ftotalimpuestos = GLOBAL.FORMATO_MONEY(this.totalimpuestos);
          this.ftotales = GLOBAL.FORMATO_MONEY(this.totales);
          this.fecha_inicio_reporte = fechainicio;
          this.fecha_final_reporte = fechafin;

          // NUEVO: resumen por medios de pago
          this.calcularResumenMediosPago();
        })
        .catch((error) => {

          try {
            let mensaje = error.response.data;
            console.log(mensaje);


            // Mostrar mensaje de éxito
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
              },
            });

            Toast.fire({
              icon: "error",
              title: mensaje,
            });


          } catch (error) { }


        })
        .finally(() => {
          this.loading = false; // Finaliza el indicador de carga
        });
    },

    buildExcelUrl() {
      var fechainicio = $("#fechainicio").val();
      var fechafin = $("#fechafin").val();
      var documentos = GLOBAL.DOCUMENTO.FACTURA_POS;
      var format = "excel";

      var url1 =
        GLOBAL.API_GET_REPORTE_VENTAS_PLACA +
        "?fechainicio=" +
        fechainicio +
        ":00.000" +
        "&fechafin=" +
        fechafin +
        ":59.999" +
        "&tipo=" +
        documentos +
        "&tercerouniqueid=" +
        this.cliente +
        "&format=" +
        format;

      return url1;
    },

    async getReporteEquiposExcel() {
      const url = this.buildExcelUrl();
      this.loading = true;
      try {
        // Hacemos la solicitud utilizando axios, y especificamos el tipo de respuesta como blob para manejar archivos
        const response = await axios.get(url, {
          responseType: "blob", // Necesitamos blob para manejar archivos binarios como Excel
          headers: {
            Authorization: `Basic ${this.person.token}`,
            Environment: this.person.empresas,
          },
        });

        // Verificamos si la respuesta es correcta
        if (response.status === 200) {
          // Creamos un blob a partir de la respuesta
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // Creamos una URL para descargar el archivo
          const downloadUrl = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = "reporte_ventas_placa.xlsx"; // Nombre del archivo que se descargará
          document.body.appendChild(a);
          a.click();
          a.remove();
        } else {
          console.error("Error en la respuesta", response.status);
        }
      } catch (error) {
        console.error("Error al generar el reporte", error);
      } finally {
        // Asegurarse de que loading sea false sin importar el resultado
        this.loading = false;
      }
    },

    formatDate(value) {
      return value;
    },
    formatCurrency(value) {
      return value;
    },
  },
};
</script>
<style scoped>
.text-truncate {
  width: 300px !important;
}
</style>
